import { render } from "./CadastroTipoUsuarioView.vue?vue&type=template&id=a9fc5ba0&scoped=true"
import script from "./CadastroTipoUsuarioView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoUsuarioView.vue?vue&type=script&lang=js"

import "./CadastroTipoUsuarioView.vue?vue&type=style&index=0&id=a9fc5ba0&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9fc5ba0"]])

export default __exports__